(function () {
  const cfg = window.EurusFreeGift;
  if (!cfg || !cfg.threshold || !cfg.variantIds || cfg.variantIds.length === 0) return;

  const THRESHOLD = cfg.threshold * 100; // Shopify uses cents
  const VARIANTS  = cfg.variantIds.filter(Boolean).map(String);
  const PROP      = '_free_gift';
  let busy = false;

  async function sync() {
    if (busy) return;
    busy = true;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());

      // Subtotal excluding any free gifts already in cart
      const paid = cart.items.reduce((sum, i) =>
        i.properties?.[PROP] ? sum : sum + i.line_price, 0);

      const qualifies = paid >= THRESHOLD;

      for (const id of VARIANTS) {
        const line = cart.items.find(i => String(i.variant_id) === id && i.properties?.[PROP]);
        if (qualifies && !line) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1, properties: { [PROP]: 'true' } }] })
          });
        } else if (!qualifies && line) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 })
          });
        }
      }

      // Re-render cart UI
      if (window.Alpine?.store('xCartHelper')) {
        Alpine.store('xCartHelper').reRenderSections(null);
      }
    } finally {
      busy = false;
    }
  }

  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('eurus:cart:items-changed', sync);
  document.addEventListener('eurus:product:added', sync);
  window.addEventListener('pageshow', e => { if (e.persisted) sync(); });
})();
